import { motion } from "framer-motion";
import { useSiteContent } from "@/context/SiteContent";

const EASE = [0.16, 1, 0.3, 1];

const reveal = {
  hidden: { opacity: 0, y: 32 },
  show: { opacity: 1, y: 0, transition: { duration: 0.75, ease: EASE } },
};

export default function About() {
  const { content } = useSiteContent();
  const t = content.texts || {};
  const p1 = t.about_p1 || "Ich heiße Justin, bin 21 Jahre alt und baue mir gerade — ohne großes Startkapital — Schritt für Schritt etwas Eigenes auf: ein Studio für Webdesign und Clothing.";
  const p2 = t.about_p2 || "Meine Idee ist einfach: Aus deiner Idee mache ich ein echtes Produkt. Websites und Online-Shops, die ich komplett selbst baue. Clothing-Designs, die ich von Hand skizziere. Und wer seine eigene Brand will, begleite ich bis sie verkaufsbereit ist.";
  const quote = t.about_quote || "„Ich bin keine Agentur mit zehn Ansprechpartnern — ich bin jung, motiviert und mache jedes Projekt persönlich. Genau das macht den Unterschied.“";
  return (
    <section
      id="ueber-mich"
      data-testid="about-section"
      className="px-6 lg:px-12 py-24 lg:py-40"
    >
      <div className="max-w-[1600px] mx-auto">
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "100px" }}
          className="max-w-4xl"
        >
          <p className="text-xs uppercase tracking-[0.35em] text-zinc-500 mb-8">
            Über mich · Justin, 21
          </p>
          <h2
            data-testid="about-headline"
            className="font-display uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl mb-10"
          >
            Jung anfangen. Arbeiten. <br />
            <span className="text-zinc-400">Etwas Eigenes aufbauen.</span>
          </h2>

          <div className="grid md:grid-cols-2 gap-8 lg:gap-14 text-base lg:text-lg leading-relaxed text-zinc-500 mb-14">
            <p>{p1}</p>
            <p>{p2}</p>
          </div>

          <p className="font-editorial italic text-2xl lg:text-3xl text-zinc-700 leading-snug max-w-3xl">
            {quote}
          </p>
        </motion.div>
      </div>
    </section>
  );
}
